export default __webpack_public_path__ + "static/media/ssmb.736437e7.svg";